import templateUrl from "./pagination.html";

export const paginationComponent = {
  bindings: {
    onChange: "&",
    totalItems: "<",
    currentPage: "<",
    itemPerPage: "<",
    totalItemsPerPageCount: "<",
  },
  templateUrl,
  controller: class PaginationComponent {
    $onInit() {
      this.maxSize = 3;
    }
    _onChange() {
      this.onChange({
        $event: this.currentPage,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/pagination/pagination.component.js